
import { AccountController } from "@/app/ui/controllers/AccountController";
import combinedForeignLabelAsset from "@/app/ui/assets/svg/sti-reverse-scan/icon-dangerous-goods-woodpacking-text-en.svg";
import combinedLabelAsset from "@/app/ui/assets/svg/sti-reverse-scan/icon-dangerous-goods-woodpacking-text.svg";
import { prop, Vue } from "vue-class-component";

class Props {
  flag = prop<string>({ default: "", type: String });
  isStiDest = prop<boolean>({
    default: false,
    required: false,
    type: Boolean
  });
  regionName = prop<string>({
    default: "",
    required: false,
    type: String
  });
}

export default class DangerousGoodsWoodpackingIcon extends Vue.with(Props) {
  get isForeignAccount() { return AccountController.accountData.accountIsForeign; }
  get combinedLabelAsset() {
    return this.isForeignAccount ? combinedForeignLabelAsset : combinedLabelAsset;
  }
  get isPod() { return /sla hari ini|lewat batas sla|delivery ulang|kiriman penting/i.test(this.flag); }
  get isOverdue() { return /lewat batas sla/i.test(this.flag); }
  get isUrgent() { return /kiriman penting/i.test(this.flag); }
}
